<mat-card
  class="eiq-card eiq-card-shadow"
  [attr.data-testid]="testId() ? testId() + '-card' : null"
  [ngClass]="[style(), clickable() ? 'clickable' : '', disabled() ? 'disabled' : '', shadow() ? 'shadow' : '']"
  [attr.role]="clickable() ? 'button' : 'region'"
  (click)="clicked.emit()"
>
  <div class="eiq-clickable-overall"></div>

  @if (title()) {
    <mat-card-title [class.no-content]="noContent()">
      <div class="title" [ngClass]="headerStyle()">
        <div class="title-content">
          <ng-content select="[slot=prefix]"></ng-content>
          <h2 [ngClass]="titleStyle()">{{ title() }}</h2>
        </div>
        <ng-content select="[slot=subtitle]"></ng-content>
      </div>
      <ng-content select="[slot=actions]"></ng-content>
    </mat-card-title>
  }
  <mat-card-content [class.no-title]="!title()">
    <ng-content select="[slot=content]"></ng-content>
  </mat-card-content>
</mat-card>
